import { assetsUrl } from '@awork/environments/environment'

/**
 * Standard way to get asset images
 * @param {string} name
 * @returns
 */
export function getAssetImage(name: string) {
  return `${assetsUrl}images/${name}`
}
